import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './fotos-albert-gerrits.css'

const FotosAlbertGerrits = (props) => {
  return (
    <div className="fotos-albert-gerrits-container10">
      <Helmet>
        <title>Fotos-Albert-Gerrits - Schrijf je vrij</title>
        <meta
          property="og:title"
          content="Fotos-Albert-Gerrits - Schrijf je vrij"
        />
      </Helmet>
      <div className="fotos-albert-gerrits-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name27"></NavbarInteractive>
      </div>
      <div id="main-section" className="fotos-albert-gerrits-main">
        <div
          data-thq="slider"
          data-navigation="true"
          data-pagination="false"
          className="fotos-albert-gerrits-slider swiper"
        >
          <div
            data-thq="slider-wrapper"
            className="fotos-albert-gerrits-hie-rslider-wrapper swiper-wrapper"
          >
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-oproep swiper-slide"
            >
              <div className="fotos-albert-gerrits-container11">
                <img
                  alt="image"
                  src="/Albert Gerrits/a1%20oproep%20arbeitseinsatz-800w.jpg"
                  className="fotos-albert-gerrits-image10"
                />
                <span className="fotos-albert-gerrits-text10">
                  <span className="Content fotos-albert-gerrits-text11">
                    Ab, geboren in 1921, dient zich op 17 mei 1943 aan te melden
                    voor de Arbeitseinsatz. Zie bijgaande oproep.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br className="Content fotos-albert-gerrits-text12"></br>
                  <br className="Content fotos-albert-gerrits-text13"></br>
                  <br className="Content fotos-albert-gerrits-text14"></br>
                  <br className="Content fotos-albert-gerrits-text15"></br>
                  <br className="Content fotos-albert-gerrits-text16"></br>
                  <br className="Content fotos-albert-gerrits-text17"></br>
                  <span className="Schuingedrukt_tekst">
                    NIOD, beeldnummer 107150
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-diploma swiper-slide"
            >
              <div className="fotos-albert-gerrits-container12">
                <img
                  alt="image"
                  src="/Albert Gerrits/a2%20diploma%20kruideniersbedrijf-800w.jpg"
                  className="fotos-albert-gerrits-image11"
                />
                <span className="fotos-albert-gerrits-text19">
                  Ab heeft de oproep voor de Arbeitseinsatz genegeerd en haalt
                  tien dagen later zijn diploma Vakbekwaamheid
                  Kruideniersbedrijf. 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-onderduik swiper-slide"
            >
              <div className="fotos-albert-gerrits-container13">
                <div className="fotos-albert-gerrits-container14">
                  <img
                    alt="image"
                    src="/Albert Gerrits/a3%20samen%20in%20oolde-2-800w.jpg"
                    className="fotos-albert-gerrits-image12"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/a32%20luiken%20oolde-800w.jpeg"
                    className="fotos-albert-gerrits-image13"
                  />
                </div>
                <span className="fotos-albert-gerrits-text20">
                  <span>
                    Ab duikt onder bij een oom en tante in Oolde in de
                    Achterhoek (1943). To komt op bezoek.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Eronder de boerderij met nog steeds dezelfde luikjes in
                    2018.  
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-wachttorena swiper-slide"
            >
              <div className="fotos-albert-gerrits-container15">
                <img
                  alt="image"
                  src="/Albert Gerrits/a4%20wachttoren%20amerfoort%20zwwit-800w.jpeg"
                  className="fotos-albert-gerrits-image14"
                />
                <span className="fotos-albert-gerrits-text25">
                  <span>
                    Ab wordt verraden, opgepakt en naar Kamp Amersfoort
                    gebracht. Op de foto een wachttoren, nog steeds aanwezig bij
                    het Nationaal Monument Kamp Amersfoort. 
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    {' '}
                    Op
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <a
                    href="https://www.oorlogsbronnen.nl/bronnen?term=kamp+amersfoort&amp;tab=foto&amp;page=1"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="fotos-albert-gerrits-link"
                  >
                    oorlogsbronnen.nl
                  </a>
                  <span>
                    {' '}
                    kun je veel foto&apos;s vinden van Kamp Amersfoort in de
                    Tweede Wereldoorlog.
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-transportkaart-buchenwald swiper-slide"
            >
              <div className="fotos-albert-gerrits-container16">
                <div className="fotos-albert-gerrits-container17">
                  <img
                    alt="image"
                    src="/Albert Gerrits/a5%20transportkaart%201%20en%202%20samen-800w.jpg"
                    className="fotos-albert-gerrits-image15"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/a52%20transportlijst%20rheine%2018-04-44%20def-800w.jpg"
                    className="fotos-albert-gerrits-image16"
                  />
                </div>
                <span className="fotos-albert-gerrits-text31">
                  <span className="fotos-albert-gerrits-text32">
                    Na zes weken Amersfoort wordt Ab met 498 anderen met de
                    trein naar Rheine gebracht om op het vliegveld tewerkgesteld
                    te worden. Eenmaal over de grens horen ze dat er geen plek
                    is en worden ze naar concentratiekamp Buchenwald gebracht.
                    Waarom op het eerste blad Buchenwald al vermeld stond?
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <br></br>
                  <br className="Schuingedrukt_tekst"></br>
                  <br className="Schuingedrukt_tekst"></br>
                  <span className="Schuingedrukt_tekst">
                    ITS Digital Archive
                  </span>
                  <br className="Schuingedrukt_tekst"></br>
                  <span className="Schuingedrukt_tekst">
                    {' '}
                    Copy of 1.1.1.2. / 26003 en 26004
                  </span>
                  <br></br>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-buchenwald swiper-slide"
            >
              <div className="fotos-albert-gerrits-container18">
                <div className="fotos-albert-gerrits-container19">
                  <img
                    alt="image"
                    src="/Albert Gerrits/a6%20buchenwald%20poort-800w.jpg"
                    className="fotos-albert-gerrits-image17"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/a62%20jedem%20das%20seine1-800w.jpg"
                    className="fotos-albert-gerrits-image18"
                  />
                </div>
                <span className="fotos-albert-gerrits-text41">
                  Op 19 april 1944 komen ze aan in concentratiekamp Buchenwald
                  bij Weimar met de tekst in de poort: Jedem das Seine (Ieder
                  het zijne). 
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-registratie-buchenwald swiper-slide"
            >
              <div className="fotos-albert-gerrits-container20">
                <div className="fotos-albert-gerrits-container21">
                  <img
                    alt="image"
                    src="/Albert Gerrits/a7%20bw%20kaart%201-800w.jpg"
                    className="fotos-albert-gerrits-image19"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/a72%20bw%20kaart%202-800w.jpg"
                    className="fotos-albert-gerrits-image20"
                  />
                </div>
                <span className="fotos-albert-gerrits-text42">
                  <span>
                    In concentratiekamp Buchenwald moet hij zijn spullen
                    afgeven, die op verschillende kaarten geregistreerd worden.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    {' '}
                    Daaronder zijn gevangenenregistratie met foto. Hoe het
                    registratieproces eraan toe ging, lees je in mijn boek.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Later is in het rood toegevoegd dat de kleding door de
                    vijand vernietigd is. Buchenwald is op 24 augustus 1944 door
                    de Amerikanen gebombardeerd. 
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br className="Schuingedrukt_tekst"></br>
                  <span className="Schuingedrukt_tekst">
                    ITS Digital Archive
                  </span>
                  <br className="Schuingedrukt_tekst"></br>
                  <span className="Schuingedrukt_tekst">
                    {' '}
                    Copy of 1.1.5.3. / 5942548 en 5942551
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-arbeitskommando swiper-slide"
            >
              <div className="fotos-albert-gerrits-container22">
                <img
                  alt="image"
                  src="/Albert Gerrits/a8%20kommando%20zimmerei-800w.jpg"
                  className="fotos-albert-gerrits-image21"
                />
                <span className="fotos-albert-gerrits-text57">
                  <span className="fotos-albert-gerrits-text58">
                    Als Ab weg wilde bij een arbeidscommando, ging hij stiekem
                    bij een ander commando staan. Dat hij nooit betrapt is mag
                    een wonder heten. Hier zie je dat hij niet is komen opdagen
                    voor de timmerwerkzaamheden bij de Deutsche Ausrüstungswerke
                    (nicht weiter angetreten staat dwars achter zijn naam).
                  </span>
                  <br className="fotos-albert-gerrits-text59"></br>
                  <br className="fotos-albert-gerrits-text60"></br>
                  <br className="fotos-albert-gerrits-text61"></br>
                  <span className="fotos-albert-gerrits-text62">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="Schuingedrukt_tekst">
                    ITS Digital Archive
                  </span>
                  <br className="Schuingedrukt_tekst"></br>
                  <span className="Schuingedrukt_tekst">
                    {' '}
                    Copy of 1.1.5.1. / 5329205
                  </span>
                  <br></br>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-brieven swiper-slide"
            >
              <div className="fotos-albert-gerrits-container23">
                <div className="fotos-albert-gerrits-container24">
                  <img
                    alt="image"
                    src="/Albert Gerrits/a9%20brief%20ab4%20voorkant%20juni%2044-800w.jpg"
                    className="fotos-albert-gerrits-image22"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/a92%20brief%20ab4%20juni%2044-800w.jpg"
                    className="fotos-albert-gerrits-image23"
                  />
                </div>
                <span className="fotos-albert-gerrits-text67">
                  Een van de bewaard gebleven brieven die Ab naar huis
                  geschreven heeft. De streep erdoorheen geeft aan dat deze
                  gecensureerd is.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-met-pa-buchenwald-oproep swiper-slide"
            >
              <div className="fotos-albert-gerrits-container25">
                <img
                  alt="image"
                  src="/Albert Gerrits/b1%20pa%20in%20buchenwald%20hek%20klein-800w.jpg"
                  className="fotos-albert-gerrits-image24"
                />
                <span className="fotos-albert-gerrits-text68">
                  Op zijn tachtigste is hij terug in Buchenwald en heeft hij
                  zijn herinneringen met mij gedeeld.  Hier staat hij voor de
                  ingang van het voormalige kamp.
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide2fotos-stollen swiper-slide"
            >
              <div className="fotos-albert-gerrits-container26">
                <div className="fotos-albert-gerrits-container27">
                  <img
                    alt="image"
                    src="/Albert Gerrits/b2%20landhaus-800w.jpg"
                    className="fotos-albert-gerrits-image25"
                  />
                  <img
                    alt="image"
                    src="/Albert Gerrits/b22%20ingang%20stollen1-800w.jpg"
                    className="fotos-albert-gerrits-image26"
                  />
                </div>
                <span className="fotos-albert-gerrits-text69">
                  <span>
                    In een buitenkamp van Buchenwald, Langenstein-Zwieberge,
                    werd hij ondergebracht in een tot slaapzaal omgebouwd
                    restaurant van een Landhuis.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Hij moest werken in de zogenaamde Stollen. Tunnels uitgraven
                    zodat er uit het zicht van de geallieerden onderdelen voor
                    geheime wapens gemaakt konden gaan worden.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-slide"
              className="fotos-albert-gerrits-slide1foto-oker swiper-slide"
            >
              <div className="fotos-albert-gerrits-container28">
                <img
                  alt="image"
                  src="/Albert Gerrits/b3%20oker-800w.jpg"
                  className="fotos-albert-gerrits-image27"
                />
                <span className="fotos-albert-gerrits-text74">
                  Ab kwam in Oker terecht maar heeft niet in de genoemde
                  chemische fabriek gewerkt. Hoe hij daar kwam en wat hij daar
                  wel deed lees je in het boek.
                </span>
              </div>
            </div>
          </div>
          <div
            data-thq="slider-pagination"
            className="swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
          >
            <div
              data-thq="slider-pagination-bullet"
              className="swiper-pagination-bullet swiper-pagination-bullet-active"
            ></div>
          </div>
          <div
            data-thq="slider-button-prev"
            className="fotos-albert-gerrits-slider-button-prev swiper-button-prev"
          ></div>
          <div
            data-thq="slider-button-next"
            className="fotos-albert-gerrits-slider-button-next swiper-button-next"
          ></div>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name27"></Footer>
    </div>
  )
}

export default FotosAlbertGerrits
